import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import handleValidDate from "../../../helpers/utils/handleValidDate";
import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../../config";
import defaultImg from "../../../assets/images/upload.png";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getMarital } from "../../../store/marital/action";
import { getMaritalTax } from "../../../store/maritalTax/action";
import { getReligion } from "../../../store/religion/action";
import { getIdentityType } from "../../../store/identityType/action";
import { getBank } from "../../../store/bank/action";
import { getEducationLevel } from "../../../store/educationLevel/action";
import { getFamilyContactType } from "../../../store/familyContactType/action";
import { deleteFile } from "../../../store/file/action";
import { resetEmployeeState, getEmployee as onGetEmployees, addNewEmployee as onAddNewEmployee, updateEmployee as onUpdateEmployee, deleteEmployee as onDeleteEmployee, getEmployeeLoading } from "../../../store/employee/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultProfileImg from "../../../assets/images/users/user-dummy-img.jpg";
import ModalInputFile from "../../../Components/ModalInputFile";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import ExportDoc from "../../../Components/Common/ExportDoc";
import { useRef } from "react";

const Employee = (props) => {
  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, employees, isEmployeeCreated, isEmployeeSuccess, loading, error, maritals, maritalLoading, maritalTaxs, maritalTaxLoading, religions, religionLoading, companies, companyLoading, identityTypes, identityTypeLoading, banks, bankLoading, familyContactTypes, familyContactTypeLoading, educationLevels, educationLevelLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    employees: state.Employee.employees,
    isEmployeeCreated: state.Employee.isEmployeeCreated,
    isEmployeeSuccess: state.Employee.isEmployeeSuccess,
    loading: state.Employee.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    maritals: state.Marital.maritals,
    maritalLoading: state.Marital.loading,
    maritalTaxs: state.MaritalTax.maritalTaxs,
    maritalTaxLoading: state.MaritalTax.loading,
    religions: state.Religion.religions,
    religionLoading: state.Religion.loading,
    identityTypes: state.IdentityType.identityTypes,
    identityTypeLoading: state.IdentityType.loading,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    familyContactTypes: state.FamilyContactType.familyContactTypes,
    familyContactTypeLoading: state.FamilyContactType.loading,
    educationLevels: state.EducationLevel.educationLevels,
    educationLevelLoading: state.EducationLevel.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    error: state.Employee.error,
  }));

  const [clientList, setClientList] = useState([]);
  const [logo, setLogo] = useState(defaultImg);
  const [employeeList, setEmployeeList] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [maritalList, setMaritalList] = useState([]);
  const [maritalTaxList, setMaritalTaxList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [identityTypeList, setIdentityTypeList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [familyContactTypeList, setFamilyContactTypeList] = useState([]);
  const [educationLevelList, setEducationLevelList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [familyContactItem, setFamilyContactItem] = useState([]);
  const [educationItem, setEducationItem] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [employeeDoc, setEmployeeDoc] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [modalMedia, setModalMedia] = useState(false);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const [mediaType, setMediaType] = useState("");

  const [open, setOpen] = useState("2");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const statusGenderData = [
    {
      options: [
        { label: "Pria", value: "Pria" },
        { label: "Wanita", value: "Wanita" },
      ],
    },
  ];

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  useEffect(() => {
    if (companySelected && companySelected.value) {
      dispatch(resetEmployeeState());
      dispatch(onGetEmployees({ companyId: companySelected.value }));

      dispatch(getBank());
      dispatch(getReligion());
      dispatch(getMarital());
      dispatch(getMaritalTax());
      dispatch(getIdentityType());
      dispatch(getEducationLevel());
      dispatch(getFamilyContactType());
    }
  }, [companySelected]);

  const onClickDelete = (employee) => {
    setEmployee(employee);
    setDeleteModal(true);
  };

  const onClickApprove = (employee) => {
    setEmployee(employee);
    setApproveModal(true);
  };

  const handleDeleteEmployee = () => {
    if (employee) {
      dispatch(onDeleteEmployee(employee));
      setDeleteModal(false);
    }
  };

  const handleApproveEmployee = () => {
    if (employee) {
      employee.setApprove = true;
      dispatch(onUpdateEmployee(employee));
      setApproveModal(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(employees)) {
      let filteredEmployees = employees;
      if (activeTypeTab !== "all") {
        filteredEmployees = employees.filter((employee) => employee.employee_status.name === activeTypeTab);
      }
      setEmployeeList(filteredEmployees.map((el) => ({ ...el, isChecked: false })));
      if (employees[employees.length - 1]) {
        let files = [];
        let fileData = employees[employees.length - 1].employee_file && employees[employees.length - 1].employee_file.length > 0 ? employees[employees.length - 1].employee_file : [];
        for (const f of fileData) {
          files.push({ filename: f.filename, originalname: f.originalname });
        }
        setOriginalFiles(files);
      }
    }
    else {
      setEmployeeList([]);
      setOriginalFiles([]);
    }
  }, [employees]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(identityTypes)) {
      var data = [];
      var opt = [];
      identityTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setIdentityTypeList(data);
    }
  }, [identityTypes]);

  useEffect(() => {
    if (!isEmpty(maritalTaxs)) {
      var data = [];
      var opt = [];
      maritalTaxs.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const gender = item.gender;
        const id = item.id;
        var obj = {
          label: gender + ", " + code + " - " + name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setMaritalTaxList(data);
    }
  }, [maritalTaxs]);

  useEffect(() => {
    if (!isEmpty(maritals)) {
      var data = [];
      var opt = [];
      maritals.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setMaritalList(data);
    }
  }, [maritals]);

  useEffect(() => {
    if (!isEmpty(religions)) {
      var data = [];
      var opt = [];
      religions.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setReligionList(data);
    }
  }, [religions]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  useEffect(() => {
    if (!isEmpty(familyContactTypes)) {
      var data = [];
      var opt = [];
      familyContactTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setFamilyContactTypeList(data);
    }
  }, [familyContactTypes]);

  useEffect(() => {
    if (!isEmpty(educationLevels)) {
      var data = [];
      var opt = [];
      educationLevels.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEducationLevelList(data);
    }
  }, [educationLevels]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredEmployees = employees;
      if (type !== "all") {
        filteredEmployees = employees.filter((employee) => employee.employee_status.name === type);
      }
      setEmployeeList(filteredEmployees);
    }
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama Karyawan",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "NIK",
        isSelected: true,
        data: [],
      },
      {
        id: "username",
        label: "Username",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "Telepon",
        isSelected: true,
        data: [],
      },
      {
        id: "email",
        label: "Email",
        isSelected: true,
        data: [],
      },
      {
        id: "employee_department",
        label: "Departemen",
        isSelected: true,
        data: [],
      },
      {
        id: "employee_position",
        label: "Position",
        isSelected: true,
        data: [],
      },
      {
        id: "employee_address",
        label: "Alamat",
        isSelected: true,
        data: [],
      },
    ];

    if (employeeList.length > 0) {
      employeeList.forEach((data) => {
        if (data.isChecked) {
          let doc;
          for (const item of Object.keys(data)) {
            if (dataDoc.find((d) => d.id === item)) {
              doc = dataDoc.find((d) => d.id === item);
              if (doc.id === "joinat") {
                doc.data.push(data.joinat !== null ? handleValidDate(data.joinat) : "-");
              } else if (doc.id === "employee_address") {
                doc.data.push(`${data.employee_address[0]?.description}`);
              } else {
                doc.data.push(data[doc.id]);
              }
            }
          }

          const employee_department = dataDoc.find((d) => d.id === "employee_department");
          employee_department.data.push(`${data.employee_user?.user_department?.name}`);

          const username = dataDoc.find((d) => d.id === "username");
          username.data.push(`${data.employee_user?.username}`);

          const employee_position = dataDoc.find((d) => d.id === "employee_position");
          employee_position.data.push(`${data.employee_user?.user_position?.name}`);
        }
      });
    }

    setEmployeeDoc(dataDoc);
  }, [employeeList]);

  const toggle = useCallback(() => {
    if (modal) {
      setEmployee(null);
      setSelectedFiles([]);
      setFamilyContactItem([]);
      setEducationItem([]);
      setOtherDocImg([]);
      setCompanyList([]);
      setTimeout(() => {
        setModal(false);
      }, 100);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleEmployeeClick = useCallback(
    (arg) => {
      const employee = arg;
      let fc = [];
      let edu = [];

      if (employee.employee_family_contact.length > 0) {
        employee.employee_family_contact.forEach((element) => {
          fc.push({
            type: { label: element.family_contact_type.name, value: element.family_contact_type.id },
            id: element.id,
            name: element.name,
            email: element.email,
            phone: element.phone,
          });
        });
      }
      if (employee.employee_education.length > 0) {
        employee.employee_education.forEach((element) => {
          edu.push({
            level: { label: element.education_level.name, value: element.education_level.id },
            id: element.id,
            name: element.name,
            startat: element.startat,
            endat: element.endat,
          });
        });
      }
      let files = [];
      let fileData = employee.employee_file.length > 0 ? employee.employee_file : [];
      for (const f of fileData) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }

      setFamilyContactItem(fc);
      setEducationItem(edu);
      setOtherDocImg(files);

      let address_employee = {};
      for (const address of employee.employee_address) {
        if (address.isPrimary) {
          address_employee = address;
        }
      }

      let identity_employee = {};
      for (const identity of employee.employee_identity) {
        if (identity.isPrimary) {
          identity_employee = identity;
        }
      }

      let bank_employee = {};
      for (const bank of employee.employee_bank) {
        if (bank.isPrimary) {
          bank_employee = bank;
        }
      }

      setPlaceDefaultVal({
        label: `${address_employee.village} ${address_employee.district} ${address_employee.city} ${address_employee.province} ${address_employee.country}`,
        value: `${address_employee.village} ${address_employee.district} ${address_employee.city} ${address_employee.province} ${address_employee.country}`,
      });

      setEmployee({
        id: employee.id,
        imageKTP: employee.imageKTP ?? "",
        imageVaksin: employee.imageVaksin ?? "",
        imageHealth: employee.imageHealth ?? "",
        imageSigned: employee.imageSigned ?? "",
        client: employee.employee_client && {
          label: employee.employee_client ? employee.employee_client.name : "",
          value: employee.employee_client ? employee.employee_client.id : "",
        },
        company: employee.employee_company && {
          label: employee.employee_company ? employee.employee_company.name : "",
          value: employee.employee_company ? employee.employee_company.id : "",
        },
        user: employee.employee_user && {
          label: employee.employee_user ? employee.employee_user.name : "",
          value: employee.employee_user ? employee.employee_user.id : "",
        },
        name: employee.name ?? "",
        email: employee.email ?? "",
        username: employee.employee_user ? employee.employee_user.username : "",
        password: employee.employee_user ? employee.employee_user.pass : "",
        phone: employee.phone ?? "",
        joinat: employee.joinat ?? "",
        birthat: employee.birthat ?? "",
        birth_place: employee.birth_place ?? "",
        tax_number: employee.tax_number ?? "",
        insurance_number: employee.insurance_number ?? "",
        description: employee.description ?? "",
        number: employee.employee_bank && employee.employee_bank.length > 0 ? employee.employee_bank[0].number : "",
        identityType: {
          label: identity_employee.identity_type ? identity_employee.identity_type.name : "",
          value: identity_employee.identity_type ? identity_employee.identity_type.id : "",
        },
        identity: identity_employee.identity_number ?? "",
        gender: { label: employee.gender, value: employee.gender },
        religion: employee.employee_religion && {
          label: employee.employee_religion ? employee.employee_religion.name : "",
          value: employee.employee_religion ? employee.employee_religion.id : "",
        },
        maritalStatus: employee.employee_marital_status && {
          label: employee.employee_marital_status ? employee.employee_marital_status.name : "",
          value: employee.employee_marital_status ? employee.employee_marital_status.id : "",
        },

        maritalTax: employee.employee_marital_tax && {
          label: employee.employee_marital_tax ? employee.employee_marital_tax.name : "",
          value: employee.employee_marital_tax ? employee.employee_marital_tax.id : "",
        },
        address: {
          label: `${address_employee.village} ${address_employee.district} ${address_employee.city} ${address_employee.province} ${address_employee.country}`,
          value: `${address_employee.village} ${address_employee.district} ${address_employee.city} ${address_employee.province} ${address_employee.country}`,
        },
        street: address_employee.description ?? "",
        zip: address_employee.code ?? "",

        village: address_employee.village ?? "",
        district: address_employee.district ?? "",
        city: address_employee.city ?? "",
        province: address_employee.province ?? "",
        country: address_employee.country ?? "",
        bank: { label: employee.employee_bank && employee.employee_bank.length > 0 && employee.employee_bank[0].bank_data_bank && employee.employee_bank[0].bank_data_bank.name, value: employee.employee_bank && employee.employee_bank.length > 0 && employee.employee_bank[0].bank_data_bank && employee.employee_bank[0].bank_data_bank.id },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = employeeList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setEmployeeList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = employeeList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setEmployeeList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      let files = [];
                      for (const f of data.employee_file) {
                        files.push({ filename: f.filename, originalname: f.originalname });
                      }
                      setOriginalFiles(data.employee_file);
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateEmployee") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleEmployeeClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteEmployee") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveEmployee") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `You are going to APPROVE recruitment of ${data.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                  {data.statusId === 3 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveEmployee") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `You are going to APPROVE recruitment of ${data.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>AKTIVASI
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        filterable: true,
        accessor: "name",
      },
      {
        Header: "ID",
        accessor: "code",
        filterable: true,
      },
      // {
      //   Header: "No. Rekening Bank",
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     let data = cellProps.row.original;
      //     let bankNumber = "-";
      //     if (data.employee_bank) {
      //       for (const bank of data.employee_bank) {
      //         if (bank.isPrimary) {
      //           bankNumber = bank.number;
      //         }
      //       }
      //     }
      //     return bankNumber;
      //   },
      // },
      {
        Header: "Posisi",
        accessor: "employee_user.user_position.name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div>
              <p className="mb-0 ">{data.employee_user && data.employee_user.user_position ? data.employee_user.user_position.name : "-"}</p>
              <p className="mb-0 text-muted fs-11">{data?.employee_user?.user_department?.par_dep ? data?.employee_user?.user_department?.name + " < " + data?.employee_user?.user_department?.par_dep?.name : data?.employee_user?.user_department?.par_dep?.name ? data?.employee_user?.user_department?.name : "-"}</p>
            </div>
          );
        },
      },
      {
        id: "Departemen",
        Header: "Departemen",
        accessor: (data) => (data?.employee_user?.user_department?.par_dep ? data?.employee_user?.user_department?.par_dep?.name + " -> " + data?.employee_user?.user_department?.name : data?.employee_user?.user_department?.name),
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return data?.employee_user?.user_department?.par_dep ? data?.employee_user?.user_department?.par_dep?.name + " -> " + data?.employee_user?.user_department?.name : data?.employee_user?.user_department?.par_dep?.name ? data?.employee_user?.user_department?.name : "-";
        },
      },
      // {
      //   Header: "No. Rekening Bank",
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     let data = cellProps.row.original;
      //     let bankNumber = "-";
      //     if (data.employee_bank) {
      //       for (const bank of data.employee_bank) {
      //         if (bank.isPrimary) {
      //           bankNumber = bank.number;
      //         }
      //       }
      //     }
      //     return bankNumber;
      //   },
      // },
      {
        Header: "Perusahaan",
        accessor: "employee_company.name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "employee_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [employeeList, handleEmployeeClick, userType, userRole, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = employeeList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setEmployeeList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => employeeList, [employeeList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Departemen"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected.value ?? "",
    };
    dispatch(onGetEmployees(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setEmployeeList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(onGetEmployees({ companyId: companySelected.value }));
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (employee && employee.name) ?? "",
      username: (employee && employee.username) ?? "",
      password: (employee && employee.password) ?? "",
      admin: (employee && employee.admin) ?? "",
      email: (employee && employee.email) ?? "",
      phone: (employee && employee.phone) ?? "",
      client: (employee && employee.client) || clientSelected,
      company: (employee && employee.company) || companySelected,
      joinat: (employee && employee.joinat) ?? "",
      birthat: (employee && employee.birthat) ?? "",
      birth_place: (employee && employee.birth_place) ?? "",
      tax_number: (employee && employee.tax_number) ?? "",
      number: (employee && employee.number) ?? "",
      insurance_number: (employee && employee.insurance_number) ?? "",
      description: (employee && employee.description) ?? "",
      identity: (employee && employee.identity) ?? "",
      identity_type: (employee && employee.identityType) ?? "",
      employee_status: (employee && employee.status) ?? "",
      bank: (employee && employee.bank) ?? "",
      gender: (employee && employee.gender) ?? "",
      religion: (employee && employee.religion) ?? "",
      marital_status: (employee && employee.maritalStatus) ?? "",
      marital_tax: (employee && employee.maritalTax) ?? "",
      zip: (employee && employee.zip) ?? "",
      address: (employee && employee.address) ?? "",
      street: (employee && employee.street) ?? "",
      imageKTP: (employee && employee.imageKTP) ?? "",
      imageVaksin: (employee && employee.imageVaksin) ?? "",
      imageHealth: (employee && employee.imageHealth) ?? "",
      imageSigned: (employee && employee.imageSigned) ?? "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Silahkan Isi Username").nullable(true),
      password: Yup.string().min(6, "Kata sandi minimal harus terdiri dari 6 karakter").required("Diperlukan Password"),
      name: Yup.string().required("Silahkan Isi Nama Karyawan").nullable(true),
      joinat: Yup.string().required("Silahkan Isi Tanggal Masuk").nullable(true),
      phone: Yup.string().required("Silahkan Isi Nomor Telepon").nullable(true),
      birthat: Yup.string().required("Silahkan Isi Tanggal Lahir").nullable(true),
      birth_place: Yup.string().required("Silahkan Isi Tempat Lahir").nullable(true),
      tax_number: Yup.string().required("Silahkan Isi No. Pajak"),
      insurance_number: Yup.string().required("Silahkan Isi Nomor Asuransi").nullable(true),
      identity: Yup.string().required("Silahkan Isi Identitas").nullable(true),
      company: Yup.object().required("Silahkan Isi Perusahaan").nullable(true),
      client: Yup.object().required("Silahkan isi Grup Perusahaan").nullable(true),
      identity_type: Yup.object().required("Silahkan Isi ").nullable(true),
      bank: Yup.object().required("Silahkan Isi Bank").nullable(true),
      number: Yup.string().required("Silahkan Isi No. Rek. Bank").nullable(true),
      gender: Yup.object().required("Silahkan Isi Jenis Kelamin").nullable(true),
      religion: Yup.object().required("Silahkan Isi Agama").nullable(true),
      marital_status: Yup.object().required("Silahkan Isi").nullable(true),
      marital_tax: Yup.object().required("Silahkan Isi Pajak Perkawinan").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let editDataSubmit = {
          id: employee.id,
          clientId: values.client.value,
          companyId: values.company.value,
          email: values.email,
          username: values.username,
          password: values.password,
          name: values.name,
          phone: values.phone,
          joinat: values.joinat,
          birthat: values.birthat,
          birth_place: values.birth_place,
          tax_number: values.tax_number,
          insurance_number: values.insurance_number,
          description: values.description,
          identityId: values.identity_type.value,
          identity: values.identity,
          bankId: values.bank.value,
          number: values.number,
          gender: values.gender.value,
          religion: values.religion.value,
          maritalId: values.marital_status.value,
          maritalTaxId: values.marital_tax.value,
          zip: values.zip,
          village: null,
          district: null,
          city: null,
          province: null,
          country: null,
          street: values.street,
          imageKTP: values.imageKTP,
          imageVaksin: values.imageVaksin,
          imageHealth: values.imageHealth,
          imageSigned: values.imageSigned,
          family_contact: familyContactItem.length > 0 ? JSON.stringify(familyContactItem) : "[]",
          education: educationItem.length > 0 ? JSON.stringify(educationItem) : "[]",
          files: [],
        };

        dispatch(onUpdateEmployee(editDataSubmit));
      } else {
        var addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,
          username: values.username,
          password: values.password,
          name: values.name,
          email: values.email,
          phone: values.phone,
          joinat: values.joinat,
          birthat: values.birthat,
          birth_place: values.birth_place,
          tax_number: values.tax_number,
          insurance_number: values.insurance_number,
          description: values.description,
          identityId: values.identity_type.value,
          identity: values.identity,
          bankId: values.bank.value,
          number: values.number,
          gender: values.gender.value,
          religion: values.religion.value,
          maritalId: values.marital_status.value,
          maritalTaxId: values.marital_tax.value,
          zip: values.zip,
          village: null,
          district: null,
          city: null,
          province: null,
          country: null,
          street: values.street,
          imageKTP: values.imageKTP,
          imageVaksin: values.imageVaksin,
          imageHealth: values.imageHealth,
          imageSigned: values.imageSigned,
          family_contact: familyContactItem.length > 0 ? JSON.stringify(familyContactItem) : "[]",
          education: educationItem.length > 0 ? JSON.stringify(educationItem) : "[]",
          files: [],
        };

        dispatch(onAddNewEmployee(addDataSubmit));
      }

      validation.resetForm();
      toggle();
    },
  });

  function handleFamilyContactAdd() {
    let fc = [];
    if (familyContactItem && familyContactItem.length) {
      familyContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      type: { label: "Select Type", value: 0 },
      name: "",
      email: "",
      phone: "",
    });
    setFamilyContactItem(fc);
  }

  function handleEducationAdd() {
    let fc = [];
    if (educationItem && educationItem) {
      educationItem.forEach((element) => {
        fc.push(element);
      });
    }
    fc.push({
      level: { label: "Select Education", value: 0 },
      name: "",
      startat: "",
      endat: "",
    });
    setEducationItem(fc);
  }

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteEmployee(element.value));
    });
    checkall.checked = false;
  };

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(files);
    validation.setFieldValue("files", files);
  }

  function handleDeleteFiles(filesId) {
    const object = originalFiles.findIndex((obj) => obj.id === filesId);

    if (object > -1) {
      dispatch(deleteFile({ id: filesId }));
      originalFiles.splice(object, 1);
    }
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "ktp":
        validation.setFieldValue("imageKTP", file.filename);
        break;
      case "vaksin":
        validation.setFieldValue("imageVaksin", file.filename);
        break;
      case "health":
        validation.setFieldValue("imageHealth", file.filename);
        break;
      case "signed":
        validation.setFieldValue("imageSigned", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = otherDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setOtherDocImg(newState);
    } else {
      const index = otherDocImg.findIndex((fl) => fl.filename === file.filename);

      setOtherDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  document.title = "Rekrutmen | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={employeeList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteEmployee} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={employee && employee.name ? employee.name : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Karyawan" pageTitle="Rekrutmen" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createEmployee") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-group-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger me-2" : userRole && userRole.split(",").indexOf("deleteEmployee") !== -1 ? "btn btn-soft-danger me-2" : "d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
            <ExportDoc data={employeeDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i> SEMUA REKRUTMEN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>

                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader
                    className="bg-light p-3"
                    toggle={() => {
                      toggle();
                    }}
                  >
                    {!!isEdit ? "Ubah Rekrutmen" : "Tambah Rekrutmen"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                dispatch(setClientSelect(e));
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="username-field" className="form-label">
                              Username
                            </Label>
                            <Input name="username" id="username-field" className="form-control" placeholder="Isi Username" type="username" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.username ?? ""} invalid={validation.touched.username && validation.errors.username ? true : false} />
                            {validation.touched.username && validation.errors.username ? <FormFeedback type="invalid">{validation.errors.username}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="password-field" className="form-label">
                              Password
                            </Label>
                            <Input name="password" id="password-field" className="form-control" placeholder="Isi Password" type="password" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.password ?? ""} invalid={validation.touched.password && validation.errors.password ? true : false} />
                            {validation.touched.password && validation.errors.password ? <FormFeedback type="invalid">{validation.errors.password}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="employeename-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email
                            </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="tel" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email ?? ""} invalid={validation.touched.email && validation.errors.email ? true : false} />
                            {validation.touched.email && validation.errors.email ? <FormFeedback type="invalid">{validation.errors.email}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Telp
                            </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Isi Telp" type="tel" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                            {validation.touched.phone && validation.errors.phone ? <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="date-field" className="form-label">
                              Tanggal Bergabung
                            </Label>
                            <Flatpickr
                              name="joinat"
                              className="form-control"
                              placeholder="Pilih Tanggal"
                              options={{
                                enableTime: false,
                                altInput: true,
                                altFormat: "Y/m/d",
                                dateFormat: "Y/m/d",
                              }}
                              value={validation.values.joinat ?? ""}
                              onChange={(obj, str) => {
                                validation.setFieldValue("joinat", str);
                              }}
                            />
                            {validation.touched.joinat && validation.errors.joinat ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.joinat}
                              </small>
                            ) : null}
                          </div>
                          <div className="row">
                            <div className="col-md-7 mb-3">
                              <Label htmlFor="birth_place-field" className="form-label">
                                Tempat Lahir
                              </Label>
                              <Input name="birth_place" id="birth_place-field" className="form-control" placeholder="Isi Tempat Lahir" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.birth_place ?? ""} invalid={validation.touched.birth_place && validation.errors.birth_place ? true : false} />
                              {validation.touched.birth_place && validation.errors.birth_place ? <FormFeedback type="invalid">{validation.errors.birth_place}</FormFeedback> : null}
                            </div>
                            <div className="col-md-5 mb-3">
                              <Label htmlFor="birth_place-field" className="form-label">
                                Tanggal Lahir
                              </Label>
                              <Flatpickr
                                name="birthat"
                                className="form-control"
                                placeholder="Pilih Tanggal"
                                options={{
                                  enableTime: false,
                                  altInput: true,
                                  altFormat: "Y/m/d",
                                  dateFormat: "Y/m/d",
                                }}
                                value={validation.values.birthat ?? ""}
                                onChange={(obj, str) => {
                                  validation.setFieldValue("birthat", str);
                                }}
                              />
                              {validation.touched.birthat && validation.errors.birthat ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.birthat}
                                </small>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                Tipe Identitas
                                {identityTypeLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="identity_type"
                                value={validation.values.identity_type}
                                placeholder="Pilih Jenis"
                                onChange={(e) => {
                                  validation.setFieldValue("identity_type", e);
                                }}
                                options={identityTypeList}
                              ></Select>
                              {validation.touched.identity_type && validation.errors.identity_type ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.identity_type}
                                </small>
                              ) : null}
                            </div>
                            <div className="col-md-6 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                No. Identitas
                              </Label>
                              <Input name="identity" id="identity-field" className="form-control" placeholder="Isi No. Identitas" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.identity ?? ""} invalid={validation.touched.identity && validation.errors.identity ? true : false} />
                              {validation.touched.identity && validation.errors.identity ? <FormFeedback type="invalid">{validation.errors.identity}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Label htmlFor="bank-field" className="form-label">
                                Bank
                              </Label>
                              <Select
                                name="bank"
                                value={validation.values.bank}
                                placeholder="Pilih Bank"
                                onChange={(e) => {
                                  validation.setFieldValue("bank", e);
                                }}
                                options={bankList}
                              ></Select>
                              {validation.touched.bank && validation.errors.bank ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.bank}
                                </small>
                              ) : null}
                            </div>
                            <div className="col-md-6 mb-3">
                              <Label htmlFor="number-field" className="form-label">
                                No. Rekening Bank
                              </Label>
                              <Input name="number" id="number-field" className="form-control" placeholder="Isi No. Rekening" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.number ?? ""} invalid={validation.touched.number && validation.errors.number ? true : false} />
                              {validation.touched.number && validation.errors.number ? <FormFeedback type="invalid">{validation.errors.number}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="tax_number-field" className="form-label">
                              No. Pajak
                            </Label>
                            <Input name="tax_number" id="tax_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tax_number ?? ""} invalid={validation.touched.tax_number && validation.errors.tax_number ? true : false} />
                            {validation.touched.tax_number && validation.errors.tax_number ? <FormFeedback type="invalid">{validation.errors.tax_number}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="insurance_number-field" className="form-label">
                              No. Asuransi
                            </Label>
                            <Input name="insurance_number" id="insurance_number-field" className="form-control" placeholder="Isi No. Asuransi" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.insurance_number ?? ""} invalid={validation.touched.insurance_number && validation.errors.insurance_number ? true : false} />
                            {validation.touched.insurance_number && validation.errors.insurance_number ? <FormFeedback type="invalid">{validation.errors.insurance_number}</FormFeedback> : null}
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Label className="form-label"> Jenis Kelamin </Label>
                              <Select
                                name="gender"
                                value={validation.values.gender}
                                placeholder="Pilih Jenis"
                                onChange={(e) => {
                                  validation.setFieldValue("gender", e);
                                }}
                                options={statusGenderData}
                              ></Select>
                              {validation.touched.gender && validation.errors.gender ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.gender}
                                </small>
                              ) : null}
                            </div>
                            <div className="col-md-6 mb-3">
                              <Label htmlFor="religion" className="form-label">
                                Agama
                                {religionLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="religion"
                                value={validation.values.religion}
                                placeholder="Pilih Agama"
                                onChange={(e) => {
                                  validation.setFieldValue("religion", e);
                                }}
                                options={religionList}
                              ></Select>
                              {validation.touched.religion && validation.errors.religion ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.religion}
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Label className="form-label">Status Perkawinan</Label>
                              <Select
                                name="marital_status"
                                value={validation.values.marital_status}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  validation.setFieldValue("marital_status", e);
                                }}
                                options={maritalList}
                              ></Select>
                              {validation.touched.marital_status && validation.errors.marital_status ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.marital_status}
                                </small>
                              ) : null}
                            </div>
                            <div className="col-md-6 mb-3">
                              <Label className="form-label">Pajak Perkawinan</Label>
                              <Select
                                name="marital_tax"
                                value={validation.values.marital_tax}
                                placeholder="Pilih Pajak"
                                onChange={(e) => {
                                  validation.setFieldValue("marital_tax", e);
                                }}
                                options={maritalTaxList}
                              ></Select>
                              {validation.touched.marital_tax && validation.errors.marital_tax ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.marital_tax}
                                </small>
                              ) : null}
                            </div>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street} invalid={validation.touched.street && validation.errors.street ? true : false} />
                            {validation.touched.street && validation.errors.street ? <FormFeedback type="invalid">{validation.errors.street}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              {props.t("Kode Pos")}
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.zip ?? ""} invalid={validation.touched.zip && validation.errors.zip ? true : false} />
                            {validation.touched.zip && validation.errors.zip ? <FormFeedback type="invalid">{validation.errors.zip}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan (opsional)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} invalid={validation.touched.description && validation.errors.description ? true : false} />
                            {validation.touched.description && validation.errors.description ? <FormFeedback type="invalid">{validation.errors.description}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3 position-relative">
                            <Label htmlFor="family_contact" className="form-label">
                              Kontak Keluarga
                              {familyContactTypeLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleFamilyContactAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Tambah
                            </button>
                          </div>
                          {familyContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="row">
                                  <div className="mb-3 col-md-6">
                                    <Select
                                      name={`familyContactItem.${i}.type`}
                                      value={familyContactItem[i].type || {}}
                                      onChange={(e) => {
                                        validation.setFieldValue(`familyContactItem.${i}.type`, e);
                                        familyContactItem[i].type = e;
                                      }}
                                      options={familyContactTypeList}
                                    ></Select>
                                  </div>
                                  <div className="mb-3 col-md-6">
                                    <Input
                                      name={`familyContactItem.${i}.name`}
                                      className="form-control"
                                      placeholder="Contact name"
                                      type="text"
                                      value={familyContactItem[i].name ?? ""}
                                      onChange={(e) => {
                                        validation.setFieldValue(`familyContactItem.${i}.name`, e.target.value);
                                        familyContactItem[i].name = e.target.value;
                                      }}
                                      onBlur={validation.handleBlur}
                                    />
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="mb-3 col-md-6">
                                    <Input
                                      name={`familyContactItem.${i}.phone`}
                                      className="form-control"
                                      placeholder="Contact phone"
                                      type="text"
                                      value={familyContactItem[i].phone ?? ""}
                                      onChange={(e) => {
                                        validation.setFieldValue(`familyContactItem.${i}.phone`, e.target.value);
                                        familyContactItem[i].phone = e.target.value;
                                      }}
                                      onBlur={validation.handleBlur}
                                    />
                                  </div>
                                  <div className="mb-3 col-md-6">
                                    <Input
                                      name={`familyContactItem.${i}.email`}
                                      className="form-control"
                                      placeholder="Contact email"
                                      type="text"
                                      value={familyContactItem[i].email ?? ""}
                                      onChange={(e) => {
                                        validation.setFieldValue(`familyContactItem.${i}.email`, e.target.value);
                                        familyContactItem[i].email = e.target.value;
                                      }}
                                      onBlur={validation.handleBlur}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                          <div className="mb-3 position-relative">
                            <Label htmlFor="education" className="form-label">
                              Pendidikan
                              {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleEducationAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Tambah
                            </button>
                          </div>
                          {educationItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="row">
                                  <div className="mb-3 col-md-6">
                                    <Select
                                      name={`educationItem.${i}.level`}
                                      value={educationItem[i].level || {}}
                                      onChange={(e) => {
                                        validation.setFieldValue(`educationItem.${i}.level`, e);
                                        educationItem[i].level = e;
                                      }}
                                      options={educationLevelList}
                                    ></Select>
                                  </div>
                                  <div className="mb-3 col-md-6">
                                    <Input
                                      name={`educationItem.${i}.name`}
                                      className="form-control"
                                      placeholder="Education name"
                                      type="text"
                                      value={educationItem[i].name ?? ""}
                                      onChange={(e) => {
                                        validation.setFieldValue(`educationItem.${i}.name`, e.target.value);
                                        educationItem[i].name = e.target.value;
                                      }}
                                      onBlur={validation.handleBlur}
                                    />
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="mb-3 col-md-6">
                                    <Flatpickr
                                      name={`educationItem.${i}.startat`}
                                      className="form-control"
                                      placeholder="Start date"
                                      options={{
                                        enableTime: false,
                                        altInput: true,
                                        altFormat: "Y/m/d",
                                        dateFormat: "Y/m/d",
                                      }}
                                      value={educationItem[i].startat ?? ""}
                                      onChange={(e, src) => {
                                        validation.setFieldValue(`educationItem.${i}.startat`, src);
                                        educationItem[i].startat = src;
                                      }}
                                    />
                                  </div>
                                  <div className="mb-3 col-md-6">
                                    <Flatpickr
                                      name={`educationItem.${i}.endat`}
                                      className="form-control"
                                      placeholder="End date"
                                      options={{
                                        enableTime: false,
                                        altInput: true,
                                        altFormat: "Y/m/d",
                                        dateFormat: "Y/m/d",
                                      }}
                                      value={educationItem[i].endat ?? ""}
                                      onChange={(e, src) => {
                                        validation.setFieldValue(`educationItem.${i}.endat`, src);
                                        educationItem[i].endat = src;
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="education" className="form-label">
                              Kartu Pengenal
                              {/* {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )} */}
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("ktp");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.imageKTP !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.imageKTP === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.imageKTP}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.imageKTP}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("imageKTP", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="education" className="form-label">
                              Sertifikat Vaksin
                              {/* {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )} */}
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("vaksin");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.imageVaksin !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.imageVaksin === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.imageVaksin}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.imageVaksin}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("imageVaksin", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="education" className="form-label">
                              Dokumen Kesehatan
                              {/* {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )} */}
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("health");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.imageHealth !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.imageHealth === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.imageHealth}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.imageHealth}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("imageHealth", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="education" className="form-label">
                              Tanda Tangan
                              {/* {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )} */}
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("signed");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.imageSigned !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.imageSigned === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.imageSigned}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.imageSigned}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("imageSigned", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="education" className="form-label">
                              Dokumen lainnya
                              {/* {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )} */}
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("other");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {otherDocImg.map((otherDocFile, i) => {
                            if (otherDocFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={otherDocFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${otherDocFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{otherDocFile.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          handleDeleteFile(otherDocFile);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                          {/* <div className="mb-3">
                            <Dropzone
                              onDrop={(acceptedFiles) => {
                                handleAcceptedFiles(acceptedFiles);
                              }}>
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable" style={{ cursor: "pointer", height: "140px" }} {...getRootProps({ className: "dropzone" })}>
                                  <div className="dz-message needsclick">
                                    <div>
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                      <input {...getInputProps()} />
                                    </div>
                                    <h5>Drop employee document here.</h5>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            <div className="list-unstyled mb-0" id="file-previews">
                              {!!isEdit &&
                                (originalFiles || []).map((f, i) => {
                                  if (f.statusId !== 3) {
                                    return (
                                      <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
                                        <div className="p-2 position-relative">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">{f.mimetype.includes("image") ? <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.filename} src={process.env.REACT_APP_API_URL + "/files/" + f.path} /> : <i className="display-6 text-muted ri-function-line" />}</Col>
                                            <Col className="overflow-scroll">
                                              <Link to="#" className="text-muted font-weight-bold">
                                                {f.originalname}                      </Link>
                                              <p className="mb-0">
                                                <strong>{formatBytes(f.size)}</strong>
                                              </p>
                                            </Col>
                                          </Row>
                                          <Link
                                            to="#"
                                            className="text-danger btn-icon btn btn-sm btn-soft-danger position-absolute bottom-0 end-0 "
                                            onClick={() => {
                                              handleDeleteFiles(f.id);
                                            }}>
                                            <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                          </Link>
                                        </div>
                                      </Card>
                                    );
                                  } else return null;
                                })}
                              {selectedFiles.map((f, i) => {
                                return (
                                  <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.name} src={f.preview} />
                                        </Col>
                                        <Col>
                                          <Link to="#" className="text-muted font-weight-bold">
                                            {f.name}                  </Link>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                );
                              })}
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <CardBody className="text-left">
                <div className="row">
                  <div className=" col-lg-2">
                    <div className="avatar-md">
                      <div className="avatar-title bg-light rounded-circle">{info && info.employee_image ? <img src={process.env.REACT_APP_API_URL + "/files/" + info.employee_image.path} alt="" className="avatar-sm rounded-circle object-cover" /> : <img src={defaultProfileImg} alt="" className="avatar-sm rounded-circle object-cover" />}</div>
                    </div>
                  </div>
                  <div className="col-lg-10">
                    <h5 className="mt-3 mb-0">{info && info ? info.name : ""}</h5>
                    <p className="text-muted mb-4">{info && info.description ? info.description : "-"} </p>
                  </div>
                </div>
              </CardBody>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <Accordion id="default-accordion-example" flush open={open} toggle={toggleAccordion}>
                    <AccordionItem>
                      <AccordionHeader targetId="1" className="accordion-header" id="headingOne">
                        INFORMASI KARYAWAN
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="row">
                          <table className="table border table-responsive table-striped fs-13 mb-3">
                            <tbody>
                              <tr>
                                <td>Email</td>
                                <td>{info.email ? info.email : "-"} </td>
                              </tr>
                              <tr>
                                <td className="p2 w-50">Telp</td>
                                <td className="p2 w-50">{info.phone ? info.phone : "-"} </td>
                              </tr>
                              <tr>
                                <td className="p2 w-50">Jenis Kelamin</td>
                                <td className="p2 w-50">{info.gender ? info.gender : "-"} </td>
                              </tr>
                              <tr>
                                <td className="p2 w-50">Tempat Lahir</td>
                                <td className="p2 w-50">{info.birth_place ? info.birth_place + ", " + handleValidDate(info.birthat) : "-"} </td>
                              </tr>
                              <tr>
                                <td className="p2 w-50">Agama</td>
                                <td className="p2 w-50">{info.employee_religion ? info.employee_religion.name : "-"}</td>
                              </tr>
                              <tr>
                                <td className="p2 w-50">Status Perkawinan</td>
                                <td className="p2 w-50">{info.employee_marital_status ? info.employee_marital_status.name : "-"}</td>
                              </tr>
                              <tr>
                                <td className="p2 w-50">No. Pajak</td>
                                <td className="p2 w-50">{info.tax_number ? info.tax_number : "-"} </td>
                              </tr>
                              <tr>
                                <td className="p2 w-50">Asuransi</td>
                                <td className="p2 w-50">{info.insurance_number ? info.insurance_number : "-"} </td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table border table-responsive table-striped fs-13 mb-3">
                            <tbody>
                              <tr>
                                <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                  Identitas
                                </td>
                              </tr>
                              {info.employee_identity ? (
                                info.employee_identity.map((row) => {
                                  return (
                                    <Fragment key={row.id}>
                                      <tr>
                                        <td className="p2 w-50">Type</td>
                                        <td className="p2 w-50">
                                          {row.identity_type ? row.identity_type.name : "-"} {row.identity_number ? row.identity_number : "-"}
                                        </td>
                                      </tr>
                                    </Fragment>
                                  );
                                })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>
                          <table className="table border table-responsive table-striped fs-13 mb-3">
                            <tbody>
                              <tr>
                                <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                  Alamat
                                </td>
                              </tr>
                              {info.employee_address ? (
                                info.employee_address.map((row) => {
                                  return (
                                    <Fragment key={row.id}>
                                      <tr>
                                        <td className="p2" colSpan={2}>
                                          {row.description ? row.description : "-"}
                                        </td>
                                      </tr>
                                      {/* <tr>
                                          <td className="p2 w-50">Primary</td>
                                          <td className="p2 w-50">{row.isPrimary ? "Yes" : "No"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2 w-50">Type</td>
                                          <td className="p2 w-50">{row.address_type ? row.address_type.address_name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2 w-50">Province</td>
                                          <td className="p2 w-50">{row.av ? row.av.vp.province_name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2 w-50">City</td>
                                          <td className="p2 w-50">{row.av ? row.av.vc.city_name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2 w-50">District</td>
                                          <td className="p2 w-50">{row.av ? row.av.vd.district_name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2 w-50">Village</td>
                                          <td className="p2 w-50">{row.av ? row.av.village_name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2 w-50">Postal Code</td>
                                          <td className="p2 w-50">{row.av ? row.av.zip : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2 w-50">Street</td>
                                          <td className="p2 w-50">{row.av ? row.description : "-"} </td>
                                        </tr> */}
                                    </Fragment>
                                  );
                                })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>
                          <table className="table border table-responsive table-striped fs-13 mb-3">
                            <tbody>
                              <tr>
                                <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                  INFORMASI BANK
                                </td>
                              </tr>
                              {info.employee_bank ? (
                                info.employee_bank.map((row) => {
                                  return (
                                    <Fragment key={row.id}>
                                      <tr>
                                        <td className="p2" colSpan="2">
                                          {row.bank_data_bank ? row.bank_data_bank.name : "-"} {row.number ? row.number : "-"}
                                        </td>
                                      </tr>
                                    </Fragment>
                                  );
                                })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>

                          <table className="table border table-responsive table-striped fs-13 mb-3">
                            <tbody>
                              <tr>
                                <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                  Pendidikan
                                </td>
                              </tr>
                              {info.employee_education ? (
                                info.employee_education.map((row) => {
                                  return (
                                    <Fragment key={row.id}>
                                      <tr>
                                        <td className="p2 w-50">
                                          {row.name ? row.name : "-"} ({row.education_level ? row.education_level.name : "-"}) <br />
                                          <small>
                                            {row.startat && handleValidDate(row.startat)} - {row.endat && handleValidDate(row.endat)}
                                          </small>
                                        </td>
                                      </tr>
                                    </Fragment>
                                  );
                                })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>
                          <table className="table border table-responsive table-striped fs-13 mb-3">
                            <tbody>
                              <tr>
                                <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                  Kontak Keluarga
                                </td>
                              </tr>
                              {info.employee_family_contact ? (
                                info.employee_family_contact.map((row) => {
                                  return (
                                    <Fragment key={row.id}>
                                      <tr>
                                        <td className="p2" colSpan="2">
                                          {row.family_contact_type ? row.family_contact_type.name : "-"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="p2 w-50">Name</td>
                                        <td className="p2 w-50">{row.name ? row.name : "-"} </td>
                                      </tr>
                                      <tr>
                                        <td className="p2 w-50">Number</td>
                                        <td className="p2 w-50">{row.phone ? row.phone : "-"} </td>
                                      </tr>
                                    </Fragment>
                                  );
                                })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>
                          <div className="list-unstyled mb-0" id="file-previews">
                            {(originalFiles || []).map((f, i) => {
                              return (
                                <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
                                  <div className="p-2 position-relative">
                                    <Row className="align-items-center">
                                      {/* <Col className="col-auto">{f.mimetype.includes("image") ? <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.originalname} src={process.env.REACT_APP_API_URL + "/files/" + f.path} /> : <i className="display-6 text-muted ri-function-line" />}</Col>
                                        <Col className="overflow-scroll">
                                          <Link to="#" className="text-muted font-weight-bold">
                                            {f.originalname}                  </Link>
                                          <p className="mb-0">
                                            <strong>{formatBytes(f.size)}</strong>
                                          </p>
                                        </Col> */}
                                    </Row>
                                    <Link
                                      to="#"
                                      className="text-danger btn-icon btn btn-sm btn-soft-danger position-absolute bottom-0 end-0"
                                      onClick={() => {
                                        handleDeleteFiles(f.id);
                                      }}
                                    >
                                      <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                    </Link>
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="2" className="accordion-header" id="headingTwo">
                        INFORMASI PEKERJAAN
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        <table className="table table-responsive table-striped fs-12">
                          <tbody>
                            <tr>
                              <td className="p2 w-50"> Perusahaan</td>
                              <td className="p2 w-50">{info.employee_company && info.employee_company.name ? info.employee_company.name : "-"} </td>
                            </tr>
                            <tr>
                              <td className="p2 w-50">Tanggal Bergabung</td>
                              <td className="p2 w-50">{info.joinat ? handleValidDate(info.joinat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2 w-50">Departemen </td>
                              <td className="p2 w-50">{info.employee_user && info.employee_user?.user_department ? info.employee_user?.user_department?.name : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2 w-50"> Jabatan</td>
                              <td className="p2 w-50">{info.employee_user && info.employee_user.user_position ? info.employee_user.user_position.name : "-"} </td>
                            </tr>
                          </tbody>
                        </table>
                        <div>
                          <table className="table table-responsive table-striped fs-12">
                            <tbody>
                              <tr>
                                <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                  Kontrak
                                </td>
                              </tr>
                              {info.employee_user && info?.employee_user?.user_contract ? (
                                info?.employee_user?.user_contract?.map((row) => {
                                  return (
                                    <Fragment key={row.id}>
                                      <tr>
                                        <td className="p2" colSpan="2">
                                          {row.code ? row.code : "-"} Mulai Dari {row.startat && row.endat ? handleValidDate(row.startat) + " Sampai " + handleValidDate(row.endat) : "-"}
                                        </td>
                                      </tr>
                                    </Fragment>
                                  );
                                })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div>
                          <table className="table table-responsive table-striped fs-12">
                            <tbody>
                              <tr>
                                <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                  Lokasi Kerja
                                </td>
                              </tr>
                              {info.employee_user && info.employee_user.user_location ? (
                                info.employee_user.user_location
                                  //.filter((data) => data.isPrimary === true)
                                  .map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2" colSpan="2">
                                            {row.location_branch ? row.location_branch.name : "-"}
                                            {row.isPrimary ? ", Primary" : ""}
                                          </td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="3" className="accordion-header" id="headingThree">
                        INFORMASI LAINNYA
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <table className="table table-responsive table-striped fs-12">
                          <tbody>
                            <tr>
                              <td className="p2 w-50">Dibuat Oleh</td>
                              <td className="p2 w-50">{info.employee_createdby && info.employee_createdby.name ? info.employee_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2 w-50">Diedit Oleh</td>
                              <td className="p2 w-50">{info.employee_updatedby && info.employee_updatedby.name ? info.employee_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2 w-50">Disetujui Oleh</td>
                              <td className="p2 w-50">{info.employee_approvedby && info.employee_approvedby.name ? info.employee_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Employee.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Employee));
